import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import moment from "moment";
import { useEffect, useState ,useMemo} from "react";
import { useHistory } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../../Service/service";
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert';

const HRDesignation: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
          history.push("/login");
        } else {
        }
      }, [Id, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [loading,setloading]=useState(false)
    const [id, setId] = useState("");

    /*........... Create.......... */
    const [DesigName, setDesigName] = useState("");
    const [DesigDescription, setDesigDescription] = useState("");
    const [crtby] = useState(localStorage.getItem("SignupEmpId"));
    const [updtby] = useState(localStorage.getItem("SignupEmpId"));

    /*............ View & Update.......... */
    const [designationName, setDesignationName] = useState("");
    const [designationDescription, setDesignationDescription] = useState("");
    const [Resources, setResources] = useState([]);
  
/*................Getall Designation Api....................*/

    useEffect(() => {
        LoadDesignation();
    }, []);

    const LoadDesignation = () => {
        setloading(true);
        service.GetAllDesignationDropDown()
            .then((response) => {
                console.log("View Designation");
                console.log(response, "data");
                if (response.data.Status === "400") {
                    setData([]);
                } else {
                    setData(response.data.Data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setTimeout(() => {
                    setloading(false);
                }, 500); 
            });
    };

    /*............... Designation Datatable..................*/

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            width: "200px",
        },
        {
            name: "Designation Name",
            selector: (itm: any) => itm.designationName,
            sortable: true,
            width: "300px",
        },
        {
            name: "Created Date",
            sortable: true,
            width: "200px",
            cell: (itm: any) => {
                var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
                return (
                    <>
                        <IonText>{crDate}</IonText>
                    </>
                )
            }
        },
        {
            name: "Created By",
            width: "200px",
            selector: (itm: any) => itm.createdBy,
            sortable: true,
        },
        {
            name: "No.Of Resources",
            selector: (itm: any) => itm.noOfResources,
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText onClick={() => openmodal(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ];
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    /*....................Search Filter.....................*/

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        
        };
    
    return (
        <div style={{ display: "flex" }}>
            <div style={{ display: "flex" }}>
                <div className="form-group form-focus row">
                    <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                        value={filterText} placeholder="Search" />
                    <label className="focus-label">Search</label>
                </div>
                <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
            </div>
        </div>
    )
    
    }, [filterText, resetPaginationToggle]);

/*...................Modal.....................*/

    const openmodal = (id: any) => {
        setId(id)
        setModalopen(true);
        service.ViewDesignationById(id)
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.Data.designationName === null || response.data.Data.designationName === "") {
                        setDesignationName("");
                    }
                    else {
                        setDesignationName(response.data.Data.designationName);
                    }
                    if (response.data.Data.designationDescription === null || response.data.Data.designationDescription === "") {
                        setDesignationDescription("");
                    }
                    else {
                        setDesignationDescription(response.data.Data.designationDescription);
                    }
                }
            })
    }

    const openmodal1 = () => {
        setModalopen1(true);
    }

    const closemodal = () => {
        setModalopen(false);
    }

    const closemodal1 = () => {
        setModalopen1(false);
        setDesigName("");
        setDesigDescription("");
    }

/*................... Api for Create designation.................*/

    const Create = () => {
        if (DesigName.length === 0) {
            swal("", "Please Enter Designation Name", "info")
            return;
        }
        else if (DesigDescription.length === 0) {
            swal("", "Please Enter Designation Description", "info")
            return;
        }
        else {
            console.log('data')
            service.CreateDesignation(DesigName, DesigDescription, crtby, updtby)
                .then((response) => {
                    console.log(response.status);
                    if (response.data.status === "200") {
                        swal("", "Created Successfully", "success");
                        window.location.reload();
                    }
                    else {
                        swal("", response.data.message, "error")
                    }
                })
        }
    }

    /*...............Api for update designation..................*/

    const Update = () => {
        if (designationName.length === 0) {
            swal("", "Please Enter Designation Name", "info")
        }
        else if (designationDescription.length === 0) {
            swal("", "Please Enter Designation Description", "info")
        }
        else {
            service.UpadateDesignation(id, designationName, designationDescription, updtby)
                .then((response) => {
                    console.log(response.status);
                    if (response.data.status == "200") {
                        console.log(response.data);
                        swal("", "Updated Successfully", "success");
                        window.location.reload()
                    }
                    else {
                        swal("", response.data.message, "error");
                    }
                })
        }
    }    
    const back = () => {
        history.goBack();
    }

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Designation</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Designation </a>
                                </div>
                            </div>
                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                    <Modal
                         dialogClassName="modal-dialog modal-lg" 
                        show={modalopen}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">View Designation </h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Designation Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={designationName} onIonChange={(e: any) => setDesignationName(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Designation Description <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={designationDescription} onIonChange={(e: any) => setDesignationDescription(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                                </div>
                            </form>
                        </div>
                    </Modal>
                    <Modal
                      dialogClassName="modal-dialog modal-lg" 
                        // id="logouts-modal"
                        show={modalopen1}
                    >
                        <div className="modal-header">
                            <h5 className="modal-title">Create Designation </h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Designation Name <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={DesigName} onIonChange={(e: any) => setDesigName(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Designation Description <span className="text-danger">*</span></label>
                                    <div>
                                        <IonInput value={DesigDescription} onIonChange={(e: any) => setDesigDescription(e.detail.value)} className="form-control datetimepicker" />
                                    </div>
                                </div>
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                                </div>
                            </form>
                        </div>
                    </Modal>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default HRDesignation